
(function(global, factory) {
	typeof define === 'function' && define.amd ? define(factory) : typeof module === 'object' && module.exports ? (module.exports = factory()) : (global.KitePaymentLogos = factory());
})(this, function () {
	var logos = [
	{
		"id": "american-express",
		"name": "american-express",
		"tags": "american-express",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#FFFFFE",
					"fill-rule": "evenodd",
					"d": "M12 15h10.97V4H12v11Z",
					"clip-rule": "evenodd"
				},
				{
					"fill": "#006FAC",
					"fill-rule": "evenodd",
					"d": "M22.55 11.77H19l-.23-.3v.3h-.78v-.48a.9.9 0 0 1-.34.06h-.13v.42h-1.2l-.18-.27-.17.25h-1.89v-1.8H16l.17.24.17-.24H23V4H12v4.5l.38-.89h.76l.19.45v-.45h.93l.12.36.12-.36h4v.17a.89.89 0 0 1 .56-.17h1.25l.19.45v-.45h.75l.22.34v-.34h.8V9.4h-.77l-.2-.32v.32h-1.12l-.11-.27h-.23l-.11.27h-.67a.9.9 0 0 1-.54-.16v.16h-1.14l-.22-.3v.3H13l-.11-.27h-.24l-.1.27H12V15h11v-3.35a.8.8 0 0 1-.42.12",
					"clip-rule": "evenodd"
				},
				{
					"fill": "#006FAC",
					"fill-rule": "evenodd",
					"d": "M15.41 10.5v-.29h-1.05v1.29h1.05v-.29h-.72V11h.7v-.29h-.7v-.21h.72Zm1 1h.41l-.52-.66.52-.64h-.4l-.31.4-.3-.4h-.42l.52.65-.51.65h.4l.3-.41.31.41Zm.44-1.3v1.3h.33v-.43h.38a.44.44 0 1 0 0-.87h-.71Zm.84.44a.13.13 0 0 1-.091.136.132.132 0 0 1-.059.004h-.36v-.28h.36a.14.14 0 0 1 .15.15v-.01Zm.8.4h.13l.39.46h.4l-.41-.47a.4.4 0 0 0 .34-.4.41.41 0 0 0-.45-.42h-.69v1.29h.33l-.04-.46Zm.36-.55a.13.13 0 0 1 .15.13.13.13 0 0 1-.091.136.132.132 0 0 1-.059.004h-.36v-.26l.36-.01Zm1.66 0v-.29H19.5v1.3h1.05v-.29h-.72V11h.71v-.29h-.71v-.21l.68-.01Zm.82.72h-.63v.29h.67a.4.4 0 0 0 .44-.42.35.35 0 0 0-.4-.38h-.31a.1.1 0 0 1-.11-.1.1.1 0 0 1 .11-.1h.56l.13-.29h-.68a.41.41 0 0 0-.45.41.358.358 0 0 0 .4.38h.31a.11.11 0 0 1 .11.155.11.11 0 0 1-.11.065l-.04-.01Zm1.18 0h-.67v.29h.67a.41.41 0 0 0 .45-.42.358.358 0 0 0-.4-.38h-.31c-.07 0-.12 0-.12-.1a.11.11 0 0 1 .12-.11h.56l.12-.29h-.68a.411.411 0 0 0-.422.565.37.37 0 0 0 .382.225h.3a.11.11 0 0 1 .084.191.11.11 0 0 1-.084.029ZM13.16 9.14h.37L13 7.84h-.43L12 9.14h.36l.11-.27h.59l.1.27Zm-.58-.55.18-.44.18.44h-.36Zm1.65.55h.29l.34-1v1h.33v-1.3h-.52l-.29.83-.29-.83h-.52v1.3h.32v-1l.34 1Zm2.23-1v-.29H15.4v1.3h1.06v-.29h-.73v-.22h.71v-.29h-.71v-.21h.73Zm.51.55h.13l.38.46h.41l-.42-.47a.42.42 0 0 0 .34-.41.41.41 0 0 0-.45-.42h-.72v1.3H17l-.03-.46Zm.36-.55a.14.14 0 0 1 .15.14.141.141 0 0 1-.096.123.14.14 0 0 1-.054.007H17v-.27h.33Zm.61 1h.33v-1.3h-.33v1.3Zm1.09 0 .14-.29h-.11a.31.31 0 0 1-.33-.35.309.309 0 0 1 .33-.34h.34v-.3h-.37a.58.58 0 0 0-.62.64.572.572 0 0 0 .6.64h.02Zm1.33 0h.36l-.55-1.3h-.42l-.56 1.3h.36l.11-.27h.59l.11.27Zm-.59-.55.18-.44.18.44h-.36Zm2.23.55v-1.3h-.33v.8l-.51-.8h-.42v1.3h.33V8.3l.53.84h.4Z",
					"clip-rule": "evenodd"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "bank",
		"name": "bank",
		"tags": "bank",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#000",
					"d": "M18.35 3.18a1.3 1.3 0 0 0-1.32 0l-5 2.93v1.56h1.75v3.94h-.87v.88h9.62v-.88h-.87V7.67h1.75V6.11l-5.06-2.93Zm-3.72 4.49h2.62v3.94h-2.62V7.67Zm6.12 3.94h-2.62V7.67h2.62v3.94ZM22.5 6.8h-9.62v-.19l4.59-2.67a.46.46 0 0 1 .44 0l4.59 2.67v.19ZM23.37 13.36H12v.88h11.37v-.88Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "discover",
		"name": "discover",
		"tags": "discover",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#231F20",
					"fill-rule": "evenodd",
					"d": "M6.01 7.18c0-.06 0-.08.08-.08h1c.5-.007.984.18 1.35.52.254.241.425.556.49.9a1.81 1.81 0 0 1-.61 1.77 1.66 1.66 0 0 1-1 .42H6l.01-3.53Zm.71 2.87c0 .05 0 .07.06.07h.42a1.1 1.1 0 0 0 .69-.29 1.18 1.18 0 0 0 .34-1.14 1.08 1.08 0 0 0-.77-.88 2.11 2.11 0 0 0-.66-.06c-.06 0-.08 0-.08.08v2.22ZM27.46 9.21l1.14 1.52h-.8c-.06 0-.09 0-.13-.08l-.89-1.33a.07.07 0 0 0-.09 0v1.37c0 .07 0 .09-.09.09h-.59s-.07 0-.07-.06V7.16s0-.06.06-.06h1.21c.276.008.54.11.75.29a1 1 0 0 1 .32.86.94.94 0 0 1-.77.92l-.05.04Zm-.8-.52c0 .06 0 .07.06.07h.32a.52.52 0 0 0 .51-.52.48.48 0 0 0-.35-.51 1.54 1.54 0 0 0-.48 0c-.05 0-.07 0-.06.07v.89ZM23.48 7.18c0-.06 0-.08.06-.08h1.88c.05 0 .06 0 .06.07v.5c0 .05 0 .06-.06.06h-1.16c-.06 0-.08 0-.08.09v.65c0 .06 0 .07.07.07h1.12c.06 0 .07 0 .07.07-.01.16-.01.32 0 .48 0 .05 0 .06-.07.06h-1.11c-.06 0-.08 0-.08.08v.82c0 .06 0 .08.07.08h1.16c.06 0 .07 0 .07.07v.5h-1.9c-.06 0-.05 0-.05-.07l-.05-3.45ZM10.75 9.69a.86.86 0 0 0 .4.4.73.73 0 0 0 .61 0 .49.49 0 0 0 .3-.44.45.45 0 0 0-.27-.43c-.2-.1-.42-.16-.63-.25a1.29 1.29 0 0 1-.53-.36.85.85 0 0 1-.15-.37 1 1 0 0 1 .75-1.16 1.49 1.49 0 0 1 1.4.31v.07l-.31.41h-.07a.67.67 0 0 0-.41-.24.57.57 0 0 0-.57.17.32.32 0 0 0 .07.48c.153.093.318.167.49.22.159.058.312.128.46.21a.9.9 0 0 1 .49.78 1.14 1.14 0 0 1-.85 1.25 1.44 1.44 0 0 1-1.63-.61v-.06l.45-.38ZM19.67 7.1h.72a.07.07 0 0 1 .08.06c.22.55.84 2.12.94 2.36 0-.05.67-1.63 1-2.36 0 0 0-.06.06-.06h.73l-1.54 3.67s0 .06-.08.06a1.31 1.31 0 0 0-.28 0 .07.07 0 0 1-.07-.05c-.28-.69-1.27-3.08-1.48-3.59l-.08-.09ZM15.81 8.09a1.48 1.48 0 0 0-.41-.31 1.15 1.15 0 0 0-1.56.66 1.26 1.26 0 0 0 .24 1.36 1.12 1.12 0 0 0 .91.36 1.09 1.09 0 0 0 .72-.3l.09-.08a.05.05 0 0 1 0 .05v.79a2 2 0 0 1-2.22-.37 1.89 1.89 0 0 1 .81-3.13 1.82 1.82 0 0 1 1.41.11v.05l.01.81ZM10.01 10.65c0 .06 0 .09-.08.09h-.64V7.17c0-.06 0-.07.07-.07.19.01.38.01.57 0 .06 0 .08 0 .08.08v3.47Z",
					"clip-rule": "evenodd"
				},
				{
					"fill": "#252122",
					"fill-rule": "evenodd",
					"d": "M28.73 7.08a.28.28 0 1 0 0 .56.28.28 0 0 0 0-.56Zm0 .51a.23.23 0 1 1 .22-.23.218.218 0 0 1-.133.212.22.22 0 0 1-.087.018Z",
					"clip-rule": "evenodd"
				},
				{
					"fill": "#231F20",
					"fill-rule": "evenodd",
					"d": "m28.76 7.39.1.14h-.08l-.08-.12v.12h-.06v-.32h.11a.09.09 0 0 1 .07 0v.07a.09.09 0 0 1-.07.09l.01.02Zm-.08-.09v-.1.1Z",
					"clip-rule": "evenodd"
				},
				{
					"fill": "url(#fa)",
					"d": "M17.96 10.84a1.92 1.92 0 1 0 0-3.84 1.92 1.92 0 0 0 0 3.84Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "generic-card",
		"name": "generic-card",
		"tags": "generic-card",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#000",
					"d": "M22.93 5h-9.62A1.31 1.31 0 0 0 12 6.32v7.43h10.93a1.311 1.311 0 0 0 1.32-1.31V6.32A1.32 1.32 0 0 0 22.93 5ZM12.87 6.32a.44.44 0 0 1 .44-.44h9.62a.44.44 0 0 1 .44.44v.43h-10.5v-.43Zm0 1.31h10.5v.87h-10.5v-.87Zm10.06 5.25H12.87v-3.5h10.5v3.06a.44.44 0 0 1-.44.44Z"
				},
				{
					"fill": "#000",
					"d": "M18.12 11.13h-4.81v.88h4.81v-.88Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "generic-card-disabled",
		"name": "generic-card-disabled",
		"tags": "generic-card-disabled",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#9BA9BD",
					"d": "M22.93 5h-9.62A1.31 1.31 0 0 0 12 6.32v7.43h10.93a1.311 1.311 0 0 0 1.32-1.31V6.32A1.32 1.32 0 0 0 22.93 5ZM12.87 6.32a.44.44 0 0 1 .44-.44h9.62a.44.44 0 0 1 .44.44v.43h-10.5v-.43Zm0 1.31h10.5v.87h-10.5v-.87Zm10.06 5.25H12.87v-3.5h10.5v3.06a.44.44 0 0 1-.44.44Z"
				},
				{
					"fill": "#9BA9BD",
					"d": "M18.12 11.13h-4.81v.88h4.81v-.88Z"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "generic-card-disabled-dark",
		"name": "generic-card-disabled-dark",
		"tags": "generic-card-disabled-dark",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"d": "M22.93 5h-9.62A1.31 1.31 0 0 0 12 6.32v7.43h10.93a1.311 1.311 0 0 0 1.32-1.31V6.32A1.32 1.32 0 0 0 22.93 5ZM12.87 6.32a.44.44 0 0 1 .44-.44h9.62a.44.44 0 0 1 .44.44v.43h-10.5v-.43Zm0 1.31h10.5v.87h-10.5v-.87Zm10.06 5.25H12.87v-3.5h10.5v3.06a.44.44 0 0 1-.44.44Z",
					"fill": "#63738A"
				},
				{
					"d": "M18.12 11.13h-4.81v.88h4.81v-.88Z",
					"fill": "#63738A"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "mastercard",
		"name": "mastercard",
		"tags": "mastercard",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#FF5F00",
					"fill-rule": "evenodd",
					"d": "M19.999 9a4.993 4.993 0 0 1-1.91 3.931 4.996 4.996 0 0 1-1.91-3.93c0-1.595.748-3.016 1.91-3.932A4.993 4.993 0 0 1 19.999 9Z",
					"clip-rule": "evenodd"
				},
				{
					"fill": "#EB001B",
					"fill-rule": "evenodd",
					"d": "M18.089 12.931A4.998 4.998 0 0 1 10 9a4.999 4.999 0 0 1 8.089-3.93A4.991 4.991 0 0 0 16.179 9c0 1.595.747 3.015 1.91 3.931Z",
					"clip-rule": "evenodd"
				},
				{
					"fill": "#F79E1B",
					"fill-rule": "evenodd",
					"d": "M26.18 9a5 5 0 0 1-8.091 3.931 4.996 4.996 0 0 0 1.91-3.93 4.996 4.996 0 0 0-1.91-3.932A5 5 0 0 1 26.179 9ZM26.023 12.098v-.194h-.051l-.058.133-.058-.133h-.051v.194h.036v-.146l.055.126h.037l.054-.126v.146h.036Zm-.321 0v-.16h.065v-.033h-.165v.032h.065v.161h.035Z",
					"clip-rule": "evenodd"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	},
	{
		"id": "visa",
		"name": "visa",
		"tags": "visa",
		"styles": "",
		"viewBox": "0 0 36 18",
		"width": "36",
		"height": "18",
		"svgData": {
			"circles": "",
			"ellipses": "",
			"paths": [
				{
					"fill": "#1661A3",
					"fill-rule": "evenodd",
					"d": "M21.17 6c.5-.006.997.09 1.46.28l-.22 1.41-.15-.08a2.78 2.78 0 0 0-1.22-.25c-.63 0-.93.29-.93.56 0 .27.35.51.91.81.94.46 1.38 1 1.37 1.76 0 1.36-1.12 2.23-2.83 2.23a4.842 4.842 0 0 1-1.82-.36l.23-1.46.21.11c.474.24 1 .356 1.53.34.47 0 1-.2 1-.64 0-.28-.21-.48-.85-.8-.64-.32-1.43-.84-1.42-1.77C18.42 6.88 19.57 6 21.17 6Zm-3.41.14-1 6.5h-1.65l1-6.5h1.65Zm9.06 0 1.32 6.5h-1.51l-.2-1h-2.09l-.34 1h-1.71l2.42-6a.79.79 0 0 1 .85-.54h1.26v.04Zm-16.17 0a.68.68 0 0 1 .74.54l.55 2.92v.07l.17.9 1.59-4.43h1.73l-2.57 6.49h-1.69L9.72 6.99A6.69 6.69 0 0 0 8 6.27v-.13h2.65Zm15 1.76.11.56s.31 1.55.38 1.88h-1.31c.13-.38.64-1.82.64-1.82s.1-.38.22-.62h-.04Z",
					"clip-rule": "evenodd"
				}
			],
			"polygons": "",
			"polylines": "",
			"rects": ""
		}
	}
];
	function camelCaseFromHyphenated(s) {
		return s.replace(/-([a-z0-9])/gi, function (match, token) { return token.toUpperCase(); });
	}
	logos.forEach(function (item, i) {
		logos[camelCaseFromHyphenated(item.id)] = logos[i];
	});
	return logos;
});
